"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var connected_react_router_1 = require("connected-react-router");
var react_router_dom_1 = require("react-router-dom");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var wizardActions = require("@caddigital/sok-reducers/lib/actions/customer/wizard");
var projectActions = require("@caddigital/sok-reducers/lib/actions/project");
var projectWizard = require("@caddigital/sok-reducers/lib/actions/project/wizard");
var salesmanActions = require("@caddigital/sok-reducers/lib/actions/customer/salesman");
var Types = require("types");
var translate_1 = require("utils/translate");
var CustomerContext_1 = require("./hooks/CustomerContext");
var Step1_1 = require("./Step1/");
var Step2_1 = require("./Step2");
var Step3_1 = require("./Step3");
var Step4_1 = require("./Step4");
var Step5_1 = require("./Step5");
var NavigationButtons_1 = require("./NavigationButtons");
require("./style.scss");
var mapStateToProps = function (state) {
    return {
        admins: state.project.wizard.step1.projectAdmins,
        recepientsValues: state.project.wizard.step1.notifyFollowing,
        wizardStep: state.project.wizard.wizardStep,
        step1: state.project.wizard.step1,
        wizard: state.project.wizard,
        isSaving: state.project.wizard.isSaving,
        salesman: state.customer.salesman,
        customerUUID: state.project.wizard.step1.customer !== null
            ? state.project.wizard.step1.customer.uuid
            : null,
        customerFeatures: state.customer.wizard.step1.features,
        customerFeaturesStatus: state.customer.wizard.step1.featuresStatus,
        projectTypes: state.project.projectTypes,
        projectStatuses: state.project.projectStatuses
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    updateUrl: function (language, id) {
        return dispatch((0, connected_react_router_1.replace)("/".concat(language, "/admin/projects/").concat(id)));
    },
    createProject: function (state) {
        return dispatch(projectWizard.createProject(state.step1));
    },
    updateField: function (key) { return function (value) {
        dispatch(projectWizard.updateField(key, value));
    }; },
    updatePrintProviders: function (selectedOption) {
        dispatch(projectWizard.updateField('selectedPrintProvider', selectedOption !== null ? selectedOption : {})),
            dispatch(projectWizard.updateField('printProviders', selectedOption !== null ? selectedOption : {}));
    },
    updateBillingInformation: function (selectedOption) {
        return dispatch(projectWizard.updateField('billingInformations', selectedOption !== null ? selectedOption : {}));
    },
    updateCustomer: function (selectedOption, mode) {
        if (selectedOption !== null) {
            dispatch(projectWizard.updateField('customer', selectedOption));
            dispatch(projectWizard.getSalesRepresentiveRequest(selectedOption.uuid));
            if (mode === 'CREATE') {
                dispatch(wizardActions.fetchFeaturesRequest(selectedOption.id));
            }
        }
    },
    updateProjectAdmins: function (selectedOption) { return function (x) {
        var valuesRemoved = x.map(function (y) {
            return y.label;
        });
        dispatch(projectWizard.updateField('projectAdmins', valuesRemoved));
    }; },
    updateRecepients: function (selectedOption) {
        dispatch(projectWizard.updateField('notifyFollowing', selectedOption ? selectedOption.map(function (_a) {
            var label = _a.label;
            return label;
        }) : []));
    },
    changeStep: function (step) { return function () { return dispatch(projectWizard.changeStep(step)); }; },
    fetchCustomers: function (name) {
        if (name !== '') {
            dispatch(projectWizard.fetchCustomers(name));
        }
    },
    fetchSalesMen: function () {
        dispatch(salesmanActions.fetchRequest());
    },
    fetchPrintProviders: function () {
        dispatch(projectWizard.fetchPrintProviderRequest());
    },
    fetchProjectStatuses: function () {
        return dispatch(projectActions.StatusesActions.fetchRequest());
    },
    fetchProjectTypes: function () { return dispatch(projectActions.TypesActions.fetchRequest()); },
    setProjectStatus: function (status) {
        return dispatch(projectWizard.updateField('projectStatus', status));
    },
    setProjectType: function (status) {
        return dispatch(projectWizard.updateField('projectType', status));
    },
    clearAll: function () { return (dispatch(projectWizard.clearState()),
        dispatch(wizardActions.clearState()),
        dispatch(projectActions.StatusesActions.clear()),
        dispatch(projectActions.TypesActions.clear())); },
    saveStep: function (state) {
        return dispatch(projectWizard.saveStep(state));
    },
    onFetchProject: function (projectId) {
        return dispatch(projectWizard.modifyProjectRequest(projectId));
    },
    redirectToProject: function (language, id) {
        return dispatch((0, connected_react_router_1.replace)("/".concat(language, "/projects/").concat(id)));
    },
    finishCreateProject: function (projectId) {
        return dispatch(projectWizard.step5.finishProjectCreation(projectId));
    },
    setSalesman: function (user) {
        dispatch(projectWizard.updateField('salesRepresentive', user));
    },
    toggleBillingInformationModal: function () {
        return dispatch(projectWizard.toggleBillingInformationModal());
    },
    toggleEditBillingInformationModal: function (customer) { return dispatch(projectWizard.toggleEditBillingInformationModal(customer)); },
    removeBillingInformationCustomer: function (customer) { return dispatch(projectWizard.removeBillingInformationCustomer(customer)); },
    select: function (feature) {
        return dispatch(projectWizard.step1Features.select(feature));
    },
    unselect: function (feature) {
        return dispatch(projectWizard.step1Features.unselect(feature));
    },
    updatePrice: function (uuid, price) {
        return dispatch(projectWizard.step1Features.updatePrice(uuid, price));
    },
    setCustomerFeatures: function (features) {
        return dispatch(projectWizard.step1Features.copyAll(features));
    },
    fetchProjectFeatures: function (projectUuid) {
        return dispatch(projectWizard.step1Features.fetchFeaturesRequest(projectUuid));
    },
    fetchCustomerFeatures: function (customerId) {
        return dispatch(wizardActions.fetchFeaturesRequest(customerId));
    }
}); };
//#region Types
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
//#endregion
var getStep = function (props) { return ({
    0: React.createElement(Step1_1.Step1, __assign({}, props)),
    1: React.createElement(Step2_1.default, { projectId: props.wizard.step1.id }),
    2: React.createElement(Step3_1.default, null),
    3: React.createElement(Step4_1.Step4, null),
    4: React.createElement(Step5_1.Step5, __assign({}, props))
}); };
var ProjectsView = function (props) { return (React.createElement(CustomerContext_1.CustomerProvider, null,
    React.createElement("div", { className: "admin-projects-view" },
        React.createElement("main", { className: 'content' },
            React.createElement(sok_ui_1.BreadCrumb, null,
                React.createElement(react_router_dom_1.Link, { to: "/".concat((0, translate_1.getLanguage)()) }, "SokoPro"),
                React.createElement(react_router_dom_1.Link, { to: "/".concat((0, translate_1.getLanguage)(), "/projects") }, (0, translation_1.getLocalization)('breadcrumb/admin/projects')),
                props.wizard.step1.id === -1 ? (React.createElement(react_router_dom_1.Link, { to: "/".concat((0, translate_1.getLanguage)(), "/admin/projects") }, (0, translation_1.getLocalization)('breadcrumb/admin/projects/createNewProject'))) : ([
                    React.createElement(react_router_dom_1.Link, { to: "/".concat((0, translate_1.getLanguage)(), "/projects/").concat(props.step1.id) }, props.step1.projectName),
                    React.createElement(react_router_dom_1.Link, { to: "/".concat((0, translate_1.getLanguage)(), "/admin/projects/").concat(props.step1.id) }, (0, translation_1.getLocalization)('breadcrumb/admin/projects/editProject'))
                ])),
            React.createElement(sok_ui_1.StepBar, { currentStep: props.wizardStep, steps: ['1', '2', '3', '4', '5'], showStepText: false }),
            React.createElement(sok_ui_1.RequestStatusBox, { status: props.wizard.fetchStatus },
                (0, translation_1.getLocalization)("admin/projects/editProject/fetching"),
                (0, translation_1.getLocalization)("admin/projects/editProject/fetched"),
                (0, translation_1.getLocalization)("admin/projects/editProject/failed")),
            React.createElement(NavigationButtons_1.NavigationButtons, __assign({}, props)),
            getStep(props)[props.wizardStep])))); };
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.fetchPrintProviders();
        this.props.fetchProjectStatuses();
        this.props.fetchProjectTypes();
        this.props.fetchSalesMen();
        if (this.props.match.params.projectId) {
            this.props.onFetchProject(parseInt(this.props.match.params.projectId, 10));
        }
        else {
            this.props.updateRecepients([
                { label: 'sokopro.myynti@grano.fi' },
                { label: 'invoicing@sokopro.fi' },
                { label: 'helpdesk@sokopro.fi' }
            ]);
        }
    },
    componentWillUnmount: function () {
        this.props.clearAll();
    },
    componentDidUpdate: function (prevProps) {
        if (this.props.wizard.step1.id !== prevProps.wizard.step1.id) {
            this.props.updateUrl((0, translate_1.getLanguage)(), this.props.wizard.step1.id);
        }
        if (this.props.match.params.projectId === undefined &&
            prevProps.customerFeatures !== this.props.customerFeatures &&
            this.props.customerFeatures.length > 0) {
            this.props.setCustomerFeatures(this.props.customerFeatures);
        }
        if (prevProps.step1.uuid === null &&
            this.props.step1.uuid !== null &&
            this.props.step1.featuresStatus !== 'FETCHED') {
            this.props.fetchProjectFeatures(this.props.step1.uuid);
        }
        if (prevProps.step1.customer === null &&
            this.props.step1.customer !== null &&
            this.props.step1.featuresStatus !== 'FETCHED') {
            this.props.fetchCustomerFeatures(this.props.step1.customer.id);
        }
    }
}), recompose_1.pure);
exports.default = enhance(ProjectsView);
